module.exports = __webpack_public_path__ + "cx.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cx.svg
// module id = 765
// module chunks = 0